import React from 'react';
import { TableCell as MaterialUiTableCell, TableCellProps } from '@mui/material';

interface ITableCellProps extends TableCellProps {}

export const TableCell = ({ ...props }: ITableCellProps) => <MaterialUiTableCell {...props} />;
